module.exports = __webpack_public_path__ + "img/habenleumi.b046a28d.jpg";